import React, { Fragment, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { marked } from 'marked';

import spyglass from '../../img/spyglass_render.png';

//Wiki Sections
import { wikiSections, introSubSections, charCreationSubSections, charStatsSubSections, skillSubSections, equipSubSections, outsideCombatSubSections, combatSubSections, kaleidoSubSections, appendixSubSections } from '../../resources/arrays';

//Actions
import { addWikiPage, updateWikiPage } from '../../actions/wiki';

const CreateWikiPage = ({
    addWikiPage,
    updateWikiPage,
    wiki
}) => {

    const imgFolder = '/static/media/';

    const navigate = useNavigate();

    var [currentSection, updateCurrentSection] = useState(wikiSections[0]);
    var [currentSubsection, updateCurrentSubsection] = useState(introSubSections[0]);
    var [currentMarkdown, updateCurrentMarkdown] = useState("");

    const updateSectionDropdown = e => {
        updateCurrentSection(e.target.value);
    }

    const updateSubSectionDropdown = e => {
        updateCurrentSubsection(e.target.value);
        
        var curWikiObj = wiki.wikiPages.find(w => w.subSection === e.target.value);

        if(curWikiObj === undefined){
            updateCurrentMarkdown("");
        } else {
            updateCurrentMarkdown(curWikiObj.markdown);
        }
    }

    const textAreaChange = e => {
        var newInput = e.target.value;

        updateCurrentMarkdown(newInput);
    }

    marked.use({ 
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        silent: false,
        tokenizer: null,
        walkTokens: null
    });

    const rawMarkup = entry => {
        let rawMarkup = marked(entry, {baseUrl: imgFolder});
        console.log({ __html: rawMarkup });
        return { __html: rawMarkup };
    }

    const createWikiPage = e => {
        //Need to know if this is a new page or not
        var curWikiObj = wiki.wikiPages.find(w => w.subSection === e.target.value);

        var wikiObject = {};

        if(curWikiObj === undefined){
            var wikiObject = {
                "section": currentSection,
                "subSection": currentSubsection,
                "markdown": currentMarkdown
            }
        } else {
            var wikiObject = {
                ...curWikiObj,
                "markdown": currentMarkdown
            }
        }

        addWikiPage(wikiObject, navigate);
    }

    //console.log(wiki.wikiPages);

    return (
        <Fragment>
            <div className="wikiCreateContainer">
                <h1 className="text-orange mary-1">Create New Wiki Page</h1>
                <h2>(To begin, select a section and subsection)</h2>
                <div className="wikiCreateSubcontainer">
                    <label className="text-blue" for="wikiSection">Section:</label>
                    <select id="wikiSection" className="hmp marx-1" name="wikiSection" defaultValue={currentSection} onChange={e => updateSectionDropdown(e)}>
                        {
                        wikiSections.map((s, index) => 
                            <option key={index}>{s}</option>
                        )}
                    </select>
                    <label className="text-blue" for="wikiSubsection">Sub-Section:</label>
                    <select id="wikiSubSection" className="hmp marx-1" name="wikiSubSection" defaultValue="Please select a section" onChange={e => updateSubSectionDropdown(e)}>
                        {
                            currentSection === wikiSections[0] ? introSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[1] ? charCreationSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[2] ? charStatsSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[3] ? skillSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[4] ? equipSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[5] ? outsideCombatSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[6] ? combatSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[7] ? kaleidoSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            currentSection === wikiSections[8] ? appendixSubSections.map((s, index) => <option key={index}>{s}</option>) :
                            <option>Please select a section</option>
                        }
                    </select>
                </div>
                <div className="wikiCreateSubcontainer">
                    <div className="markdownPanel">
                        <div className="markdownRibbon">
                            <div>P</div>
                            <div>H1</div>
                            <div>H2</div>
                            <div><b>B</b></div>
                            <div><i>I</i></div>
                        </div>
                        <label className="text-blue" for="wikiMarkdownEditor">Enter Markdown Here:</label>
                        <textarea rows="50" className="wikiMarkdownEditor" name="wikiMarkdownEditor" onChange={textAreaChange} value={currentMarkdown} disabled={currentSubsection === "" ? true : false}/>
                    </div>
                    <div className="htmlPanel">
                        <div className="text-blue">Preview</div>
                        <div className="wikiMarkdownViewer" dangerouslySetInnerHTML={rawMarkup(currentMarkdown)}></div>
                    </div>
                </div>
                <div className="wikiCreateSubcontainer">
                    <div className="wikiSubmitButton" onClick={e => createWikiPage(e)}>Save Wiki Page</div>
                </div>
            </div>
        </Fragment>
    )
}

CreateWikiPage.propTypes = {
    addWikiPage: PropTypes.func.isRequired,
    wiki: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    wiki: state.wiki
});


export default connect(mapStateToProps, { addWikiPage })(CreateWikiPage);